"use strict";

// .closest
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// throttle
function throttle(delay, fn) {
  var last, deferTimer;
  return function() {
    var context = this, args = arguments, now = +new Date;
    if(last && now < last + delay)       {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() { last = now; fn.apply( context, args ); }, delay);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function getTransitionDuration (element) {
  return parseFloat(window.getComputedStyle(element).getPropertyValue('transition-duration')) * 1000;
}

window.wbBackdrop = (function () {

  var backdrop = document.getElementById('wb-bckdrp19'),
      sidenavClose = document.getElementById('sidenav_close'),
      classBackdropHidden = 'wb-bckdrp19--hidden',
      classBackdropSidenav = 'wb-bckdrp19--sidenav',
      classBackdropSearch = 'wb-bckdrp19--search',
      classBackdropFlyout = 'wb-bckdrp19--flyout';

  function hide () {
    /*if(window.location.href.includes('/blogs/')){backdrop.classList.add(classBackdropHidden)}
    if(window.location.href.includes('/contact')){backdrop.classList.add(classBackdropHidden)}*/
    backdrop.classList.add(classBackdropHidden);
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
  }

  function show () {
    backdrop.classList.remove(classBackdropHidden);
  }

  function showForSidenav (top) {
    /*if(window.location.href.includes('/blogs/')){backdrop.classList.add(classBackdropSidena)}
    if(window.location.href.includes('/contact')){backdrop.classList.add(classBackdropSidena)}*/
    backdrop.classList.add(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
    show();
  }

  function setCloseTop(top) {
    sidenavClose.style.top = top;
  }

  function showForSearch () {
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.add(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
    show();
  }

  function showForFlyout () {
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.add(classBackdropFlyout);
    show();
  }

  return {
    hide: hide,
    show: show,
    showForSidenav: showForSidenav,
    showForSearch: showForSearch,
    showForFlyout: showForFlyout,
    setCloseTop: setCloseTop
  }

})();


// TODO: Measure scroll bar width and set it as padding on body?

window.wbMenu = (function (menu, before, after) {

  var classMenuMobileOpen = 'wb-header__sidenav--open',
      classHtmlMenuOpened = 'wb-menumobile--opened',
      classHtmlNoOverflow = 'wb-nooverflow';

  var html = document.documentElement,
      backdrop = document.getElementById('wb-bckdrp19');

  var pagecenter = document.getElementById('page-center');

  var isOpen = false;

  var duration = getTransitionDuration(pagecenter);
  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function showMenu () {
    isOpen = true;
    resetTimeout();
    menu.classList.add(classMenuMobileOpen);
    if (typeof before === 'function') {
      before.call(null, isOpen);
    }
    html.classList.add(classHtmlNoOverflow);
    html.classList.add(classHtmlMenuOpened);
    window.wbBackdrop.showForSidenav();
    timer = setTimeout(function () {
      if (typeof after === 'function') {
        after.call(null, isOpen);
      }
    }, duration);
  }

  function hideMenu () {
    isOpen = false;
    resetTimeout();
    if (typeof before === 'function') {
      before.call(null, isOpen);
    }
    html.classList.remove(classHtmlMenuOpened);
    window.wbBackdrop.hide();
    timer = setTimeout(function () {
      html.classList.remove(classHtmlNoOverflow);
      menu.classList.remove(classMenuMobileOpen);
      if (typeof after === 'function') {
        after.call(null, isOpen);
      }
    }, duration);
  }

  function toggleMenu () {
    isOpen = !isOpen;
    if (isOpen) {
      showMenu();
    } else {
      hideMenu();
    }
  }

  function onBackdropClicked (event) {
    event.preventDefault();
    isOpen = true;
    toggleMenu();
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    if(backdrop != undefined){
      backdrop.addEventListener('click', onBackdropClicked);
    }
  });


  return {
    show: showMenu,
    hide: hideMenu,
    toggle: toggleMenu,
  };

});



window.wbHeader = (function () {

  var header = document.getElementById('wb-hdr19'),
      headerMain = document.querySelector('.wb-hdr19-main'),
      headerSidenav = document.getElementById('header-sidenav');

  //
  // MENU TOGGLE
  //
  var menuToggle = (function () {

    var banner = document.getElementById('wb-hdr19-banner');

    var classHeaderToggled = 'wb-hdr19-top__toggle--toggled',
        toggle;

    var pagecenter = document.getElementById('page-center'),
        classPagecenterOntop = 'page-center--ontop';
    var y = undefined;

    // var onResize = throttle(150, function () {
    //   window.wbHeaderSidenav.hide();
    // });

    // Focus an element without letting the browser scroll to it. #wb-hdr19 is
    // `position: sticky`, and focusing a descendant of a sticky element scrolls
    // to its layout position — the top of the document — which threw the user
    // back to scroll 0 every time the mobile nav was closed. preventScroll is
    // not honoured by older Safari, so the offset is restored as a fallback.
    function focusWithoutScroll (el) {
      if (!el || typeof el.focus !== 'function') { return; }
      var sx = window.pageXOffset, sy = window.pageYOffset;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
      if (window.pageXOffset !== sx || window.pageYOffset !== sy) {
        window.scrollTo(sx, sy);
      }
    }

    function afterToggle (isOpen) {
      // a11y: keep the burger's expanded state in sync and move keyboard/screen-reader
      // focus into the opened menu (its close button) and back to the burger on close.
      if (toggle) { toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); }
      if (isOpen) {
        var closeButton = headerSidenav && headerSidenav.querySelector('.wb-header-sidenav__close');
        if (closeButton && !headerSidenav.contains(document.activeElement)) { focusWithoutScroll(closeButton); }
      } else if (toggle) {
        // Only pull focus back to the burger for keyboard users. On a mouse or
        // touch close, activeElement is <body> and moving focus is both
        // pointless and a second chance to disturb the scroll position.
        // html.wb-kbd-nav is set on Tab / cleared on pointer press by
        // snippets/a11y-announcer.liquid.
        var kbd = document.documentElement.classList.contains('wb-kbd-nav');
        var focusInMenu = headerSidenav && headerSidenav.contains(document.activeElement);
        if (focusInMenu || (kbd && document.activeElement === document.body)) {
          focusWithoutScroll(toggle);
        }
      }
      if (isOpen) {
        // setTimeout(function () {
        //   window.addEventListener('resize', onResize, { capture: true, passive: true });
        // }, 16);
      } else {
        // window.removeEventListener('resize', onResize, { capture: true, passive: true });
        y = undefined;
        setTimeout(function () {
          pagecenter.classList.remove(classPagecenterOntop);
          sidenav.resetActivePanel();
          y = undefined;
        }, 0);
      }
    }

    function beforeToggle (isOpen) {
      if (isOpen) {
        y = window.scrollY || window.pageYOffset;
        var h = window.innerHeight;
        header.style.setProperty('top', y + 'px', 'important');
        window.wbBackdrop.setCloseTop(y + 'px');
        pagecenter.classList.add(classPagecenterOntop);
        pagecenter.style.position = 'fixed';
        pagecenter.style.top = (-y) + 'px';
        pagecenter.style.height = (y + h) + 'px';
        // toggle.classList.add(classHeaderToggled);
      } else {
        // toggle.classList.remove(classHeaderToggled);
        pagecenter.style.position = '';
        pagecenter.style.height = '';
        pagecenter.style.top = '';
        header.style.top = '';
        window.wbBackdrop.setCloseTop('');
        if (typeof y !== 'undefined') {
          window.scrollTo(0, y);
          setTimeout(function () {
            var restoredY = window.scrollY || window.pageYOffset;
            if (restoredY !== y) {
              window.scrollTo(0, y);
            }
          }, 0);
        }
      }
    }

    window.wbHeaderSidenav = window.wbMenu(headerSidenav, beforeToggle, afterToggle);

    document.addEventListener('DOMContentLoaded', function () {
      toggle = document.getElementById('headertoggle');
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        window.wbHeaderSidenav.toggle();
      });
      // a11y: announce the burger as a disclosure of the mobile navigation.
      toggle.setAttribute('aria-expanded', 'false');
      if (headerSidenav && headerSidenav.id) { toggle.setAttribute('aria-controls', headerSidenav.id); }
      // a11y: Escape closes the open mobile navigation.
      document.addEventListener('keydown', function (event) {
        if ((event.key === 'Escape' || event.keyCode === 27) && headerSidenav && headerSidenav.classList.contains('wb-header__sidenav--open')) {
          window.wbHeaderSidenav.hide();
        }
      });
    }, { passive: true });

  })();


  //
  // SEARCH
  //
  var search = (function () {


    /*
    //Search Tracking
    input.addEventListener('change', function () {
      //console.log($(this).val())
      fbq('track', 'Search', {contents: 'trigger:onchange',search_string: $(this).val()});

    });
    input.addEventListener("keyup", function(event) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        //console.log($(this).val())
        fbq('track', 'Search', {contents: 'trigger:enter',search_string: $(this).val()});
      }
    });
*/


  })();


  //
  // Default Nav Setting
  //
  var default_nav = (function () {

    var selectorFlyoutFashion = 'flyout-fashion';
    var selectorFlyoutFitness = 'flyout-fitness';
    var selectorClassLogo = '.wb-hidden-header-mobile';
    var cookieFashion = '#selected-fashion';
    var cookieFitness = '#selected-fitness';
    var cookieValueFashion = 'fashion';
    var cookieValueFitness = 'fitness';
    var host = window.location.host;
    var page = window.location.pathname;
    var hash = window.location.hash;
    var default_page_cookie = 'wb-category-preference';
    var categoryButtonSelector = '.wb-hdr19-main__left__link--small';
    var categoryButtonActiveClass = 'wb-hdr19-main__left__link--selected';

    var selectorMobileFashion = '.wb-header__sidenav__main__link--title-link--default-fashion';
    var selectorMobileFitness = '.wb-header__sidenav__main__link--title-link--default-fitness';

    var newDomain = domain;


    window.wbDefaultCookie = default_page_cookie;

    // Locale root of the current storefront ('' or e.g. '/es' for Spanish on
    // the EU store). Paths are compared and built without it, so the Spanish
    // homepage /es/ behaves like / and links keep the visitor in Spanish.
    var localeRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    function withoutLocale(path) {
      if (localeRoot && (path === localeRoot || path.indexOf(localeRoot + '/') === 0)) {
        return path.slice(localeRoot.length) || '/';
      }
      return path;
    }
    function withLocale(path) {
      return path ? localeRoot + path : path;
    }

    function checkCookieExist(cookie) {
      return typeof cookie !== 'undefined';
    }

    function getDefaultPageCookie () {
      var activeCookie = Cookies.get(default_page_cookie);
      return activeCookie;
    }

    function setButtonColor (category) {
      var btn = document.querySelector(categoryButtonSelector + '[data-category="'+category+'"]');
      if(btn != null) {
        btn.classList.add(categoryButtonActiveClass);
      }
      if(category == 'fashion') {
        var btnOther = document.querySelector(categoryButtonSelector + '[data-category="fitness"]');
      } else if(category == 'fitness') {
        var btnOther = document.querySelector(categoryButtonSelector + '[data-category="fashion"]');
      }
      if(btnOther != null) {
        if(btnOther.classList.contains(categoryButtonActiveClass)) {btnOther.classList.remove(categoryButtonActiveClass)}
      }
    }

    function setDefaultPageCookie (category) {

    if (newDomain === '.myshopify.com') {
        newDomain = window.location.hostname;
    }
     Cookies.set(default_page_cookie, category, {expires: 400, path: '/', domain: newDomain});
     //hideFlyoutMenu(category);
     redirectLogoLink(category);
     redirectWishlistLink(category);
     setButtonColor(category);
     dispatchChangedEvent(category);
    }


    function redirectLogoLink(cat) {
      if (typeof cat === 'undefined') {
        return;
      }
      var logos = document.querySelectorAll('.wb-hdr19-top__logo');
      let categoryPath = getCategoryPath(cat);
      if (categoryPath) {
        logos.forEach((logo) => {
          logo.parentNode.setAttribute('href', categoryPath);
        });
      }
    }
    
    function updateWishlistLink(cat, info) {
      if (typeof cat === 'undefined' || typeof info === 'undefined') {
        return;
      }
      if ((cat === cookieValueFashion && info.nutrition > 0) || (cat === cookieValueFitness && info.sportswear > 0)) {
        // no link change if wishlist has items from other category
        return;
      }
      let wishlistPath = getWishlistPath(cat);
      var links = document.querySelectorAll('.wb-hdr19 wishlist-link .wk-button');
      if (!wishlistPath) {
        return;
      }
      links.forEach((link) => {
        if (link.getAttribute('href') !== wishlistPath) {
          link.setAttribute('href', wishlistPath);
        }
      });
      return true;
    }
    
    function redirectWishlistLink(cat) {
      // updateWishlistLink(cat);
      document.addEventListener('wk:app:ready', () => {
        window.WishlistKing.state.observeWishlist({wishlistId: 'mine'}).subscribe(wishlist => {
          const info = wishlist.items.reduce((info, item) => {
            if (item.product?.tags) {
              if (item.product.tags.includes('product_line_fashion')) {
                info.sportswear++;
              } else if (item.product.tags.includes('product_line_fitness')) {
                info.nutrition++;
              }
            }
            return info;
          }, { sportswear: 0, nutrition: 0 });
          updateWishlistLink(cat, info);
        });
      });
    }

    function hideFlyoutMenu (cat) {

      var flyoutFashion = document.getElementsByClassName('wb-hdr19-main__flyout--page-fashion');
      var flyoutFitness = document.getElementsByClassName('wb-hdr19-main__flyout--page-fitness');
      $(flyoutFashion).remove();
      $(flyoutFitness).remove();
    }

    function removeCookie () {
      if (newDomain === '.myshopify.com') {
          newDomain = window.location.hostname;
      }
      Cookies.remove(default_page_cookie, {expires: 7, path: '/', domain: newDomain});
      dispatchChangedEvent(null);
    }

    function getData(category) {
      if (typeof category === 'undefined') {
        category = getDefaultPageCookie();
      }
      return {
        category: category || null,
        path: getCategoryPath(category),
      };
    }

    function getCategoryPath(category) {
      switch (category) {
        case cookieValueFashion: return withLocale('/pages/sportswear');
        case cookieValueFitness: return withLocale('/');
        default: return null;
      }
    }
    
    function getWishlistPath(category) {
      switch (category) {
        case cookieValueFashion: return withLocale('/collections/shop-sportswear/wishlist');
        case cookieValueFitness: return withLocale('/collections/shop-fitness/wishlist');
        default: return null;
      }
    }

    function dispatchChangedEvent(category) {
      document.dispatchEvent(new CustomEvent('wb:defaultPageCategoryChanged', {detail: getData(category)}));
    }

    function init() {
      if (window.GeoRedirect && GeoRedirect.isBot()) {
        return;
      }
      var categoryCookie = getDefaultPageCookie();
      var currentCategory = categoryCookie;
      var url = withoutLocale(window.location.pathname);
      if(hash == '#noredirect') {
        // removeCookie();
        return;
      }
      
      if(url.includes('/pages/') || url.includes('/collections/')) {
        if (url.includes('sportswear')) {
          setDefaultPageCookie('fashion');
          currentCategory = 'fashion';
        } else if (url.includes('fitness')) {
          setDefaultPageCookie('fitness');
          currentCategory = 'fitness';
        } else {
          if(typeof categoryCookie !== 'undefined') {
            setDefaultPageCookie(categoryCookie);
          }
        }
      } else if (url.includes('/products/')){
        if(header_product_tags == null) {console.log('products null');return;}
        if(header_product_tags.includes('product_line_fashion')) {
          setDefaultPageCookie('fashion');
          currentCategory = 'fashion';
        } else if (header_product_tags.includes('product_line_fitness')) {
          setDefaultPageCookie('fitness');
          currentCategory = 'fitness';
        } else {
          console.log('tag not found');
        }
      } else if (url == '/' && localeRoot) {
        // Localised homepage (e.g. /es/): it is the Nutrition homepage, but
        // init2() does not redirect here, so highlight Nutrition without
        // overwriting the visitor's stored category preference.
        if (typeof categoryCookie !== 'undefined') {
          redirectLogoLink(categoryCookie);
          redirectWishlistLink(categoryCookie);
        }
        setButtonColor(cookieValueFitness);
        currentCategory = cookieValueFitness;
      } else if (url == '/') {
        // Root is the fitness homepage — apply category state
        var rootCategory = categoryCookie || 'fitness';
        setDefaultPageCookie(rootCategory);
        currentCategory = rootCategory;
      } else {
        if(typeof categoryCookie !== 'undefined') {
          setDefaultPageCookie(categoryCookie);
        }
      }
      var $wbBody = $('.wb-body');
      $wbBody.attr('is-category',currentCategory)
    }

    function init2() {
      if (window.WBBot && window.WBBot.isBot()) {
        return;
      }
      if (window.GeoRedirect && GeoRedirect.isBot()) {
        return;
      }
      var categoryCookie = getDefaultPageCookie();
      var url = window.location.pathname;

      // #noredirect = stop redirecting, stay on /
      if (hash == '#noredirect') {
        removeCookie();
        return;
      }

      // /pages/fitness is deprecated — the root (/) is now the fitness homepage
      if (withoutLocale(url) === '/pages/fitness') {
        var fitDomain = (newDomain === '.myshopify.com') ? window.location.hostname : newDomain;
        Cookies.set(default_page_cookie, 'fitness', {expires: 400, path: '/', domain: fitDomain});
        window.location.replace(withLocale('/') + window.location.search); // replace() = no back-button trap
        return;
      }

      if (url == '/') {
        // Set cookie directly (not setDefaultPageCookie — DOM isn't ready)
        function storeCategory(category) {
          var cookieDomain = (newDomain === '.myshopify.com') ? window.location.hostname : newDomain;
          Cookies.set(default_page_cookie, category, {expires: 400, path: '/', domain: cookieDomain});
        }

        // Returning visitor: honour the stored preference straight away.
        // A crawler never carries this cookie, so no further check is needed.
        if (typeof categoryCookie !== 'undefined') {
          storeCategory(categoryCookie);
          var storedPath = getCategoryPath(categoryCookie);
          // fitness → '/' (stay); fashion → '/pages/sportswear' (redirect)
          if (storedPath && storedPath !== url) {
            window.location.pathname = storedPath;
          }
          return;
        }

        // New visitor: 75/25 random assignment (fitness-heavy)
        var assigned = Math.random() < 0.25 ? 'fashion' : 'fitness';
        var assignedPath = getCategoryPath(assigned);

        function applyAssignment() {
          storeCategory(assigned);
          // Track auto-assignment for analytics
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'category_auto_assigned',
            category_assigned: assigned
          });
          if (assignedPath && assignedPath !== url) {
            window.location.pathname = assignedPath;
          }
        }

        // 'fitness' stays on '/', so there is no redirect to gate.
        if (!assignedPath || assignedPath === url) {
          applyAssignment();
          return;
        }

        // 'fashion' would move this load to /pages/sportswear. A cookieless
        // visitor can also be a crawler or a page-speed run, and PageSpeed
        // Insights is not user-agent detectable, so confirm a real person via
        // the IP before redirecting. Skipping leaves the client on '/' with no
        // cookie and no analytics event, which is what we want for bots.
        if (window.GeoRedirect && GeoRedirect.verifyHuman) {
          GeoRedirect.verifyHuman(applyAssignment);
          return;
        }
        // No verifier available: prefer not redirecting over redirecting a bot.
      }
    }

    init2();

    if (hash === '#noredirect') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    document.addEventListener('DOMContentLoaded', function () {
      init(); //Enable after Birthday Sale

    }, { passvie: true });

    return {
      getWishlistPath: () => getWishlistPath(getDefaultPageCookie()),
      setDefaultPageCookie: setDefaultPageCookie,
      getDefaultPageCookie: getDefaultPageCookie,
      removeCookie: removeCookie,
      getData: getData,
      init: init
    }
  })();

  //
  // SIDENAV
  //
  var sidenav = (function () {

    var selectorSidenavPanelLinks = '.wb-header__sidenav__main__link[href*="#"]',
        selectorSidenavPanel = '.wb-header__sidenav__main__panel',
        classSidenavLinkPrev = 'wb-header__sidenav__main__link--prev',
        classSidenavLinkNext = 'wb-header__sidenav__main__link--next',
        classSidenavPanelHidden = 'wb-header__sidenav__main__panel--hidden',
        classSidenavPanelOpened = 'wb-header__sidenav__main__panel--opened',
        classSidenavPanelSubopened = 'wb-header__sidenav__main__panel--subopened';

    var blockMainNav = "side-nav-main",
        blockWear = "side-nav-fashion",
        blockFitness = "side-nav-fitness",
        classBlockNavs = ".wb-header__sidenav__main__link--title-link",
        classBlockActive = 'wb-header__sidenav__main__panel__list--active',
        classBlockClose = 'wb-header__sidenav__main__panel__list--close',
        categoryTitle = ".wb-header__sidenav__main__link--title",
        classActiveLink = "wb-header__sidenav__main__link--title--active";
    var activeBlockNav = null;

    var toplink = document.getElementById('headersidenav-toplink');

    var duration;
    var timer;

    function resetTimeout() {
      if (timer) {
        clearTimeout(timer);
      }
    }

    function resetNav(active){
      var mainNavs = document.querySelectorAll('.wb-header__sidenav__main__panel__list--category');
      mainNavs.forEach((element) => {
        if(element.classList.contains(classBlockActive)) {element.classList.remove(classBlockActive)}
        if(!element.classList.contains(classBlockClose)) {element.classList.add(classBlockClose)}
      });
      var defaultNav = document.querySelector('#side-nav-main');
      defaultNav.classList.add(classBlockActive);
      defaultNav.classList.remove(classBlockClose);
      active.classList.remove(classActiveLink);
    }

    function initBlockNav() {
      var cat = wbHeader.default_nav.getDefaultPageCookie();
      if(typeof cat !== 'undefined') {
        var catEl = document.querySelector('[data-category="'+cat+'"]');
        // On the index sidenav ("Choose a category") the data-category toggles aren't
        // rendered, so bail out instead of dereferencing null.
        if(!catEl){return;}
        var tthis = catEl.parentElement;
        var current = document.querySelector('.'+classBlockActive);
        if(!current){return;}
        current.classList.remove(classBlockActive);
        current.classList.add(classBlockClose);
        var category = tthis.querySelector(categoryTitle).dataset.category;
        var newActive = document.querySelector('#side-nav-'+category);
        if(!newActive){return;}
        newActive.classList.add(classBlockActive);
        newActive.classList.remove(classBlockClose);
        var activeLink = document.querySelector('.'+classActiveLink);
        if(!activeLink) {
          tthis.classList.add(classActiveLink)
        } else {
          activeLink.classList.remove(classActiveLink);
          tthis.classList.add(classActiveLink);
        }
      } else {
      }
    }

    function updateBlockNav () {
      var default_cookie = wbHeader.default_nav.getDefaultPageCookie();
      wbHeader.default_nav.setDefaultPageCookie(this.children[0].dataset.category);

      var activeLink = document.querySelector('.'+classActiveLink);
      if(activeLink == this) {
        //resetNav(this);
        return;
      }
      if(!activeLink) {
        this.classList.add(classActiveLink)
      } else {
        activeLink.classList.remove(classActiveLink);
        this.classList.add(classActiveLink);
      }
      var current = document.querySelector('.'+classBlockActive);
      if(!current){return;}
      current.classList.remove(classBlockActive);
      current.classList.add(classBlockClose);
      var category = this.querySelector(categoryTitle).dataset.category;
      var newActive = document.querySelector('#side-nav-'+category);
      if(!newActive){return;}
      newActive.classList.add(classBlockActive);
      newActive.classList.remove(classBlockClose);
    }


    function getCurrentPanel (link) {
      return link.closest(selectorSidenavPanel);
    }

    function getTargetPanel (link) {
      return document.getElementById(link.getAttribute('href').substr(1));
    }

    function showPrevPanel (panel, prevPanel) {
      resetTimeout();

      prevPanel.classList.remove(classSidenavPanelHidden);

      setTimeout(function () {
        panel.classList.remove(classSidenavPanelOpened);
        prevPanel.classList.remove(classSidenavPanelSubopened);
        prevPanel.classList.add(classSidenavPanelOpened);
      }, 16);

      timer = setTimeout(function () {
        // panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
      }, duration);
    }

    function showNextPanel (panel, nextPanel) {
      resetTimeout();

      nextPanel.scrollTop = 0;
      nextPanel.classList.remove(classSidenavPanelHidden);

      setTimeout(function () {
        panel.classList.add(classSidenavPanelSubopened);
        nextPanel.classList.add(classSidenavPanelOpened);
      }, 16);

      timer = setTimeout(function () {
        // panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
      }, duration);
    }

    function isPrevLink (link) {
      return link.classList.contains(classSidenavLinkPrev);
    }

    function isNextLink (link) {
      return link.classList.contains(classSidenavLinkNext);
    }

    function onLinkClicked (event) {
      event.preventDefault();
      if (isPrevLink(this)) {
        showPrevPanel(getCurrentPanel(this), getTargetPanel(this));
      } else if (isNextLink(this)) {
        showNextPanel(getCurrentPanel(this), getTargetPanel(this));
      }
    }


    document.addEventListener('DOMContentLoaded', function () {
      duration = getTransitionDuration(document.querySelector(selectorSidenavPanel));
      var links = document.querySelectorAll(selectorSidenavPanelLinks);
      Array.prototype.slice.call(links).forEach(function (link) {
        link.addEventListener('click', onLinkClicked);
      });

      initBlockNav();
      var blockNavs = document.querySelectorAll(classBlockNavs);
      Array.prototype.slice.call(blockNavs).forEach(function (blockNav) {
        blockNav.addEventListener('click', updateBlockNav);
      });
    }, { passvie: true });

    return {
      resetActivePanel: function () {
        var mainPanel = document.getElementById('sidenav-main');
        mainPanel.classList.remove(classSidenavPanelSubopened);
        // mainPanel.scrollTop = 0;
        mainPanel.classList.remove(classSidenavPanelHidden);
        var otherPanels = document.querySelectorAll(selectorSidenavPanel);
        Array.prototype.slice.call(otherPanels).forEach(function (panel) {
          if (panel === mainPanel) {
            return;
          }
          // panel.scrollTop = 0;
          panel.classList.add(classSidenavPanelHidden);
          panel.classList.remove(classSidenavPanelOpened);
          panel.classList.remove(classSidenavPanelSubopened);
        });
      }
    }

  })();

  //
  // CHOOSE REGION
  //
  var chooseRegion = (function () {

    var selectorHeaderMainCountryIcon = '.wb-hdr19-main__right__link__countryicon',
        selectorHeaderMainTransparentCountryIcon = '.wb-hdr19-main__top__link__countryicon',
        selectorHeaderSidenavCountryIcon = '.wb-header__sidenav__main__countryicon',
        selectorHeaderMainCountryIconTitle = '.wb-hdr19-main__right__link__countryicon-title';

    function setCountryTitle (selector, text) {
      var title = document.querySelector(selector);
      if(!title) {
        return;
      }
      title.innerText = text;
    }

    function setCountryIcon (selector, src) {
      var icon = document.querySelector(selector);
      if (!icon) {
        return;
      }
      icon.dataset.src = src;
      icon.src = src;
      icon.style.opacity = 1;
    }

    return {
      setCountryIcon: function (src, text) {
        setCountryIcon(selectorHeaderMainCountryIcon, src);
        setCountryIcon(selectorHeaderMainTransparentCountryIcon, src);
        setCountryIcon(selectorHeaderSidenavCountryIcon, src);
        setCountryTitle(selectorHeaderMainCountryIconTitle, text);
      },
    };

  })();

  //
  // CART BADGE
  //
  var cartBadge = (function () {
    var badge = document.getElementById('header-cart-badge'),
        badgeText = document.getElementById('header-cart-badge-text'),
        badgeCheck = document.getElementById('header-cart-badge-check'),
        cartLink = document.getElementById('header-cart-link'),
        classBadgeVisible = 'wb-hdr19-top__cart-badge--visible',
        classBadgeCheckVisible = 'wb-hdr19-top__cart-badge__check--visible',
        classBadgeCheckMovingFast = 'wb-hdr19-top__cart-badge__check--movingfast',
        classBadgeCheckMovingSlow = 'wb-hdr19-top__cart-badge__check--movingslow';

    var timer;

    function resetTimeout() {
      if (timer) {
        clearTimeout(timer);
      }
    }

    function updateText (count) {
      badgeText.innerText = count;
      if (parseInt(count) > 0 && !badge.classList.contains(classBadgeVisible)) {
        badge.classList.add(classBadgeVisible);
      } else if (parseInt(count) === 0) {
        badge.classList.remove(classBadgeVisible);
      }
      // Keep the cart link's accessible name in sync with the visible badge count.
      // The badge itself is aria-hidden, so screen readers rely on this label.
      if (cartLink) {
        var n = parseInt(count) || 0;
        var base = cartLink.getAttribute('data-cart-label') || '';
        if (n > 0) {
          var word = n === 1
            ? (cartLink.getAttribute('data-cart-label-one') || '')
            : (cartLink.getAttribute('data-cart-label-many') || '');
          cartLink.setAttribute('aria-label', base + ', ' + n + ' ' + word);
        } else {
          cartLink.setAttribute('aria-label', base);
        }
      }
    }

    function loadCount () {
      return axios.get('/cart.json', { headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 } }).then(function (response) {
        var itemCount = response.data.item_count || 0;
        var totalPrice = response.data.total_price || 0;
        updateText(itemCount);
        return {
          itemCount: itemCount,
          totalPrice: totalPrice,
          items: response.data.items
        };
      });
    }

    function showCheck (targetElement, onFinish, quickadd) {
      resetTimeout();
      badgeCheck.classList.remove(classBadgeCheckVisible);
      badgeCheck.classList.remove(classBadgeCheckMovingFast);
      badgeCheck.classList.remove(classBadgeCheckMovingSlow);
      badgeCheck.style.top = '';
      badgeCheck.style.right = '';

      if (typeof targetElement.get !== 'undefined') {
        targetElement = targetElement.get(0);
      }
      var badgeCheckRect = badgeCheck.getBoundingClientRect();
      var targetRect = targetElement.getBoundingClientRect();
      var width = window.innerWidth;
      var positionTop = Math.round(targetRect.top + targetRect.height/2 - badgeCheckRect.height/2 - badgeCheckRect.top + parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('top')));
      var badgeRightTmp = parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('right'));
      var positionRight1 = Math.round(width - targetRect.left - targetRect.width - (width - badgeCheckRect.left) + badgeCheckRect.width/2 + badgeRightTmp);
      var positionRight2 = Math.round(positionRight1 + targetRect.width/2);

      badgeCheck.style.top = parseInt(positionTop) + 'px';
      badgeCheck.style.right = parseInt(!!quickadd ? positionRight2 : positionRight1) + 'px';
      timer = setTimeout(function () {
        badgeCheck.classList.add(classBadgeCheckVisible);
        badgeCheck.classList.add(classBadgeCheckMovingFast);
        setTimeout(function() {
          badgeCheck.style.right = parseInt(positionRight2) + 'px';
        }, 0);
        timer = setTimeout(function () {
          badgeCheck.classList.add(classBadgeCheckMovingSlow);
          badgeCheck.classList.remove(classBadgeCheckMovingFast);
          setTimeout(function () {
            badgeCheck.style.top = '';
            badgeCheck.style.right = '';
          }, 0);
          timer = setTimeout(function () {
            loadCount().then(function () {
              badgeCheck.classList.remove(classBadgeCheckVisible);
              badgeCheck.classList.remove(classBadgeCheckMovingSlow);
              if (typeof onFinish === 'function') {
                onFinish();
              }
            });
          }, 750);
        }, 250);
      }, 300);
    }

    return {
      showCheck: showCheck,
      loadCount: loadCount
    };

  })();

  //
  // FLYOUT
  //
  var mainFlyoutMenu = (function () {

    // var backdrop = document.getElementById('wb-bckdrp19-flyout');
    // var classBackdropShow = 'wb-bckdrp19--show';

    var selectorMainLink = 'a.wb-hdr19-main__left__link',
        selectorFlyoutLink = 'a.wb-hdr19-main__flyout__left__link',
        selectorFlyoutGroup = '.wb-hdr19-main__flyout__right',
        classFlyout = 'wb-hdr19-main__flyout',
        classMainLinkActive = 'wb-hdr19-main__left__link--active',
        classFlyoutActive = 'wb-hdr19-main__flyout--active',
        classFlyoutLinkActive = 'wb-hdr19-main__flyout__left__link--active',
        classFlyoutGroupActive = 'wb-hdr19-main__flyout__right--active',
        mouseOutDelay = 250;

    var mainLeftLinks,
        mouseOutTimer,
        suppressFlyoutOpen = false;

    // Visible, focusable descendants of an open flyout (skips display:none groups).
    function getFlyoutFocusable (container) {
      return Array.prototype.slice.call(
        container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }

    function getFlyoutForLeftLink (element) {
      return element.dataset.href && element.dataset.href.substr(0, 1) === '#' && document.getElementById(element.dataset.href.substr(1));
    }

    function isFlyoutForLeftLink (flyout) {
      return flyout && flyout.classList.contains(classFlyout);
    }

    function getFlyoutLeftLinks (flyout) {
      return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutLink));
    }

    function getFlyoutRightGroups (flyout) {
      return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutGroup));
    }

    function resetMainTimeout () {
      if (mouseOutTimer) {
        clearTimeout(mouseOutTimer);
      }
    }

    function setMainLeftActive (element) {
      var flyout = getFlyoutForLeftLink(element);
      if (!isFlyoutForLeftLink(flyout)) {
        return;
      }

      element.classList.add(classMainLinkActive);
      flyout.classList.add(classFlyoutActive);
      element.setAttribute('aria-expanded', 'true');
    }

    function removeMainLeftActive () {
      mainLeftLinks.forEach(function (e) {
        var flyout = getFlyoutForLeftLink(e);
        if (!isFlyoutForLeftLink(flyout)) {
          return;
        }
        e.classList.remove(classMainLinkActive);
        flyout.classList.remove(classFlyoutActive);
        e.setAttribute('aria-expanded', 'false');
      });
    }

    function setFlyoutLeftActive (flyoutRightGroups, element) {
      var href = element.dataset.href || element.getAttribute('href');
      flyoutRightGroups.forEach(function (e) {
        if (e.hasAttribute('id')) {
          if (e.id === href.substr(1)) {
            e.classList.add(classFlyoutGroupActive);
          } else if (e.classList.contains(classFlyoutGroupActive)) {
            e.classList.remove(classFlyoutGroupActive);
          }
        }
      });
      if (href.substr(0, 1) === '#') {
        element.classList.add(classFlyoutLinkActive);
      }
    }

    function removeFlyoutLeftActive (flyoutLeftLinks, except) {
      flyoutLeftLinks.forEach(function (e) {
        if (e !== except && e.classList.contains(classFlyoutLinkActive)) {
          e.classList.remove(classFlyoutLinkActive);
        }
      });
    }

    // TODO: use one flyout and toggle children visibility

    function onMainLeftLinkMouseEnter (element) {
      resetMainTimeout();
      removeMainLeftActive();
      setMainLeftActive(element);
      // backdrop.classList.add(classBackdropShow);
    }

    function onMainLeftLinkMouseLeave (flyoutLeftLinks, flyoutRightGroups) {
      resetMainTimeout();
      mouseOutTimer = setTimeout(function () {
        resetMainTimeout();
        removeMainLeftActive();
        if (flyoutRightGroups && flyoutLeftLinks && flyoutLeftLinks[0]) {
          removeFlyoutLeftActive(flyoutLeftLinks, null);
          setFlyoutLeftActive(flyoutRightGroups, flyoutLeftLinks[0]);
        }
        // backdrop.classList.remove(classBackdropShow);
      }, mouseOutDelay);
    }


    document.addEventListener('DOMContentLoaded', function () {
      mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));
      mainLeftLinks.forEach(function (element) {
        element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
        element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
        element.addEventListener('click', function (event) {
          if (isMobile()) {
            event.preventDefault();
            return;
          }
        });

        var flyout = getFlyoutForLeftLink(element);
        if (!isFlyoutForLeftLink(flyout)) {
          return;
        }

        var flyoutLeftLinks = getFlyoutLeftLinks(flyout);
        var flyoutRightGroups = getFlyoutRightGroups(flyout);

        flyout.addEventListener('mouseenter', resetMainTimeout, { passive: true });
        flyout.addEventListener('mouseleave', onMainLeftLinkMouseLeave.bind(null, flyoutLeftLinks, flyoutRightGroups), { passive: true });

        // Keyboard: reveal the flyout when the trigger is focused, move focus into
        // it on ArrowDown (DOM-order independent), and close it on Escape.
        element.addEventListener('focus', function () {
          if (suppressFlyoutOpen) { return; }
          // Only keyboard focus should reveal the flyout. A mouse click also
          // focuses the link, and without this guard clicking a nav item would
          // pin the panel open until the pointer happened to leave it.
          try {
            if (!element.matches(':focus-visible')) { return; }
          } catch (e) { /* older browsers: fall through and open */ }
          resetMainTimeout();
          removeMainLeftActive();
          setMainLeftActive(element);
        });
        element.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown' || event.keyCode === 40) {
            event.preventDefault();
            resetMainTimeout();
            removeMainLeftActive();
            setMainLeftActive(element);
            var focusables = getFlyoutFocusable(flyout);
            if (focusables.length) { focusables[0].focus(); }
          } else if (event.key === 'Escape' || event.keyCode === 27) {
            removeMainLeftActive();
          }
        });
        // Escape from inside the panel closes it and returns focus to the trigger.
        flyout.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            suppressFlyoutOpen = true;
            removeMainLeftActive();
            element.focus();
            window.setTimeout(function () { suppressFlyoutOpen = false; }, 0);
          }
        });

        flyoutLeftLinks.forEach(function (element) {
          element.addEventListener('mouseenter', function () {
            if(element.classList.contains('gut-health-quiz-header')){
              return;
            }
            resetMainTimeout();
            removeFlyoutLeftActive(flyoutLeftLinks, element);
            setFlyoutLeftActive(flyoutRightGroups, element);
          }, { passive: true });
          element.addEventListener('focus', function () {
            if (element.classList.contains('gut-health-quiz-header')) {
              return;
            }
            resetMainTimeout();
            removeFlyoutLeftActive(flyoutLeftLinks, element);
            setFlyoutLeftActive(flyoutRightGroups, element);
          }, { passive: true });
          if (!element.dataset.href) {
            element.addEventListener('click', function (event) {
              event.preventDefault();
            });
          }
        });
      });

      var flyoutNav = document.querySelector('.wb-hdr19-main');
      if (flyoutNav) {
        // Close the flyout once keyboard focus leaves the navigation entirely.
        flyoutNav.addEventListener('focusout', function (event) {
          if (!flyoutNav.contains(event.relatedTarget)) {
            removeMainLeftActive();
          }
        });
      }
    }, { passive: true });

    return {};
  })();



  //
  // BLOG
  //
  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('wb-blog')) {
      var selectorMainLink = '.wb-hdr19-main__left__link',
          classMainLinkActive = 'wb-hdr19-main__left__link--active',
          mouseOutDelay = 250;

      var mainLeftLinks,
          activeLeftLink,
          mouseOutTimer;

      mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));

      activeLeftLink = mainLeftLinks.filter(function (element) {
        return element.classList.contains(classMainLinkActive);
      })[0];

      function resetMainTimeout () {
        if (mouseOutTimer) {
          clearTimeout(mouseOutTimer);
        }
      }

      function onMainLeftLinkMouseEnter (element) {
        resetMainTimeout();
        mainLeftLinks.forEach(function (e) {
          if (e !== element && e.classList.contains(classMainLinkActive)) {
            e.classList.remove(classMainLinkActive);
          }
        });
        element.classList.add(classMainLinkActive);
      }

      function onMainLeftLinkMouseLeave () {
        resetMainTimeout();
        mouseOutTimer = setTimeout(function () {
          resetMainTimeout();
          mainLeftLinks.forEach(function (e) {
            if (e.classList.contains(classMainLinkActive)) {
              e.classList.remove(classMainLinkActive);
            }
          });
          if (typeof activeLeftLink !== 'undefined') {
            activeLeftLink.classList.add(classMainLinkActive);
          }
        }, mouseOutDelay);
      }

      mainLeftLinks.forEach(function (element) {
        element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
        element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
      });
    }
  }, { passive: true });

  //
  // TRANSPARENCY
  //
  var transparency = (function () {
    var elContentOffset,
        classTransparent = 'wb-hdr19--transparent',
        selectorBottom = '.wb-hdr19-bottom',
        initialized = false,
        y = 0,
        o = 150;

    function hasClass() {
      return header.classList.contains(classTransparent);
    }

    function handleResize() {
      if (elContentOffset) {
        o = elContentOffset.offsetTop + 100 - header.offsetHeight;
      }
    }

    function handleBottom() {
      var has = hasClass();
      document.querySelectorAll(selectorBottom).forEach(function (element) {
        if (has) {
          element.style.display = 'none';
        } else {
          element.style.display = '';
        }
      });
    }

    function handleScroll() {
      y = window.scrollY || window.pageYOffset;
      if (y >= o) {
        if (hasClass()) {
          header.classList.remove(classTransparent);
        }
      } else {
        if (!hasClass()) {
          header.classList.add(classTransparent);
        }
      }
      handleBottom()
    }

    function init() {

    }

    function enable(element) {
      if (element) {
        elContentOffset = element;
      }
      handleResize();
      handleScroll();
      if (initialized) {
        return;
      }
      initialized = true;
      window.addEventListener('resize', throttle(50, handleResize), { passive: true });
      window.addEventListener('scroll', throttle(50, handleScroll), { passive: true });
    }

    return {
      enable: enable
    };
  })();

  //
  // HEADROOM - mobile scroll-to-hide
  //
  var headroom = (function () {
    var SCROLL_THRESHOLD = 10;
    var MOBILE_BREAKPOINT = 1300;
    var CLASS_HIDDEN = 'wb-hdr19--headroom-hidden';
    if (window.location.pathname.includes('shop-fitness') && typeof AppUserAgentDetected !== 'undefined' && AppUserAgentDetected) {
      var filterEl = document.getElementById('wb-shop-filter__main');
      if (filterEl) filterEl.classList.add('wb-hdr19--headroom-hidden-fitness-app');
    }

    var lastScrollY = 0;
    var isHidden = false;
    var enabled = false;
    var lockUntil = 0;

    function isMobileViewport() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function isSidenavOpen() {
      return document.documentElement.classList.contains('wb-menumobile--opened');
    }

    function isSearchOpen() {
      return document.body.classList.contains('wb-body__stop-bg-scroll');
    }

    function isModalOpen() {
      return document.body.classList.contains('modal-open');
    }

    function fixSafariSticky() {
      var y = window.scrollY;
      window.scrollTo(0, y + 1);
      window.scrollTo(0, y);
    }

    function pin() {
      if (!isHidden) return;
      isHidden = false;
      header.classList.add('wb-hdr19--transitioning');
      header.classList.remove(CLASS_HIDDEN);
      header.classList.remove('wb-hdr19--initially-hidden');
      document.documentElement.classList.remove('wb-headroom-hidden');
      setTimeout(function() {
        header.classList.remove('wb-hdr19--transitioning');
      }, 310);
    }

    function unpin(lockMs) {
      if (isHidden) return;
      isHidden = true;
      if (lockMs) {
        lockUntil = Date.now() + lockMs;
        lastScrollY = window.scrollY || window.pageYOffset;
      }
      header.classList.add('wb-hdr19--transitioning');
      header.classList.add(CLASS_HIDDEN);
      document.documentElement.classList.add('wb-headroom-hidden');
      setTimeout(function() {
        header.classList.remove('wb-hdr19--transitioning');
      }, 310);
    }

    function handleScroll() {
      if (!enabled) return;
      if (Date.now() < lockUntil) return;
      if (!isMobileViewport()) {
        if (isHidden) pin();
        return;
      }

      if (isSidenavOpen() || isSearchOpen() || isModalOpen()) {
        if (isHidden) pin();
        return;
      }

      var currentScrollY = window.scrollY || window.pageYOffset;

      if (currentScrollY <= 0) {
        pin();
        lastScrollY = currentScrollY;
        return;
      }

      var delta = currentScrollY - lastScrollY;

      if (Math.abs(delta) < SCROLL_THRESHOLD) {
        return;
      }

      if (delta > 0 && currentScrollY > 62) {
        unpin();
      } else if (delta < 0) {
        pin();
      }

      lastScrollY = currentScrollY;
    }

    function handleResize() {
      if (!isMobileViewport() && isHidden) {
        pin();
      }
    }

    function init() {
      if (enabled) return;
      enabled = true;
      lastScrollY = window.scrollY || window.pageYOffset;

      // On PDP pages, hide the header initially on mobile
      if (isMobileViewport() && header.classList.contains('wb-hdr19--product')) {
        unpin();
      }

      window.addEventListener('scroll', throttle(50, handleScroll), { passive: true });
      window.addEventListener('resize', throttle(150, handleResize), { passive: true });
    }

    document.addEventListener('DOMContentLoaded', init, { passive: true });

    return {
      pin: pin,
      unpin: unpin,
      init: init
    };
  })();

  //
  // RECHARGE FIX
  //
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/tools/recurring') !== -1) {
      var ids = ['#header-sidenav', '#wb-hdr19-banner', '#wb-hdr19'],
          selector = ids.map(function(id) { return id + ' [href*="/tools/recurring"]'; }).join(', ');
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function(el) {
        el.href = el.href.replace(/.*#/, '#').replace(/&.*/, '');
      });
    }
  }, { passive: true });

  return {
    setCountryIcon: chooseRegion.setCountryIcon,
    showCartCheck: cartBadge.showCheck,
    loadCartCount: cartBadge.loadCount,
    enableTransparency: transparency.enable,
    default_nav: default_nav,
    headroom: headroom/*,
    sidenav: sidenav,
    default_nav: default_nav*/
  };

})();
